import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative overflow-hidden h-screen flex flex-col justify-center gradient-hero">
      <div className="container mx-auto px-4 max-w-6xl relative z-10 text-center">
        {/* Badge */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-md rounded-full shadow-sm border border-blue-100 mb-10"
        >
          <span className="w-2 h-2 rounded-full bg-blue-600 animate-pulse"></span>
          <span className="text-sm font-medium text-gray-700">Now delivering Enterprise Solutions</span>
          <ArrowRight className="w-4 h-4 text-gray-500 ml-1" />
        </motion.div>

        {/* Heading */}
        <motion.h1 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
          className="text-5xl md:text-7xl font-bold tracking-tight text-gray-900 mb-8 leading-[1.1]"
        >
          Your Extended <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
            Engineering Team
          </span>
        </motion.h1>

        {/* Subtext */}
        <motion.p 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-12 leading-relaxed"
        >
          We are an IT Services & Talent Outsourcing company. From staff augmentation to complete project ownership, we deliver dedicated engineering teams that scale with you.
        </motion.p>

        {/* Buttons */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3, ease: "easeOut" }}
          className="flex flex-col sm:flex-row items-center justify-center gap-5"
        >
          <Link to="/contact" className="bg-blue-600 text-white text-lg font-medium px-8 py-4 rounded-full shadow-xl shadow-blue-500/20 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 flex items-center gap-2">
            Start Hiring <ArrowRight className="w-5 h-5" />
          </Link>
          <Link to="/#approach" className="bg-white text-gray-700 border border-gray-200 text-lg font-medium px-8 py-4 rounded-full shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300 flex items-center gap-2">
            <Play className="w-5 h-5 fill-current text-gray-400" /> Watch Our Approach
          </Link>
        </motion.div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-[-20%] left-[20%] w-[60%] h-[60%] bg-blue-100 rounded-full blur-[150px] opacity-40 animate-pulse"></div>
      </div>
    </section>
  );
};

export default Hero;
